module.exports = __webpack_public_path__ + "static/img/class_32.db6bf288.jpg";